'use strict';

angular.module('app.entity.field.audit').component('gridRowAudit', {
    templateUrl: 'modules/ecrd/components/field/audit/grid-row-audit/content.html',
    controller: 'GridRowAuditController',
    bindings: {
        gridId: '@',
        rowIndex: '@',
    },
});
